import React, { Suspense, lazy, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './layouts/Main';
import { NO_AUTH, requestLoginedAccount } from './Back';
import { setAccount } from './Util';

const { PUBLIC_URL } = process.env;

const About = lazy(() => import('./pages/about/About'));
const AboutLoggedIn = lazy(() => import('./pages/main_loggined/AboutLoggedIn'));
const PersonalCabinet = lazy(() => import('./pages/personal/PersonalCabinet'));
const Dogovor = lazy(() => import('./pages/legal/Dogovor'));
const Privacy = lazy(() => import('./pages/legal/Privacy'));
const NotFound = lazy(() => import('./pages/errors/404/NotFound'));
const NotAuth = lazy(() => import('./pages/errors/401/NotAuth'));

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const account = await requestLoginedAccount();
        setIsLoggedIn(account != NO_AUTH);
        setAccount(account)
      } catch (error) {
        console.error("error while checkauth", error);
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return <Main />;
  }

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Suspense fallback={<Main />}>
        <Routes>
          <Route path="/" element={isLoggedIn ? <AboutLoggedIn /> : <About />} />
          <Route path="/personal" element={(isLoggedIn) ? (<PersonalCabinet />) : (<NotAuth />)} />
          <Route path="/legal/dogovor" element={<Dogovor />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
